import {
  androidstudio,
  bootstrap,
  css,
  electron,
  expressjs,
  firebase,
  github,
  hibernate,
  html,
  java,
  js,
  mongodb,
  mysql,
  nodejs,
  oop,
  openAI,
  php,
  react,
  scenebuilder,
  springboot,
  sqlite,
  tailwind,
  ts,
  workbench,
  xampp,
} from "../../../assets";
import DalleClone from "./Images/Projects/DalleClone.webp";
import DonateLanka from "./Images/Projects/DonateLanka.webp";
import GrandCafe from "./Images/Projects/GrandCafe.webp";
import GymSite from "./Images/Projects/GymSite.webp";
import JewelleryPOS from "./Images/Projects/JewelleryPOS.webp";
import MedicalCenter from "./Images/Projects/MedicalCenter.webp";
import NoteApp from "./Images/Projects/NoteApp.webp";
import Roadsign from "./Images/Projects/Roadsign.webp";
import SimpleCalculator from "./Images/Projects/SimpleCalculator.webp";

const ProjectData = [
  {
    id: 1,
    techStack: [
      springboot,
      react,
      mysql,
      workbench,
      java,
      oop,
      html,
      css,
      github,
    ],
    category: "Web",
    categoryLink: "fab fa-chrome",
    tag: "Project",
    tagLink: "fab fa-chrome",
    image: Roadsign,
    title: "Roadsign (Website)",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://github.com/gitgunawardhana/TouristAidingSystemFrontEnd",
    text: `Introducing "Tourist Aiding System" - a comprehensive website designed exclusively for planning and enjoying vacations in Sri Lanka. 

This innovative web application offers a collection of destinations, personalized plans of a journey, reservations, and transportation options, all within one user friendly platform. By prioritizing budget considerations and catering to individual preferences, this system streamlines the trip planning process while providing a practical and enjoyable vacation experience. 

The project aims to address the challenges faced by tourists, local enterprises, and entrepreneurs, while also promoting lesser known destinations within Sri Lanka.`
      .split("\n\n")
      .map((paragraph, index) => <p key={index}>{paragraph}</p>),
  },
  {
    id: 2,
    techStack: [html, css, php, bootstrap, js, mysql, xampp],
    category: "Web",
    categoryLink: "fab fa-chrome",
    tag: "Project",
    tagLink: "fab fa-chrome",
    image: DonateLanka,
    title: "DonateLanka (Website)",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://github.com/gitgunawardhana/DonateLanka",
    text: `Introducing DonateLanka, a web site developed as part of my university project. 

This innovative system facilitates three user roles: authorizer, donor, and requester, along with an administrative role. Users can easily register on the platform, enabling requesters to seek donations and donors to contribute. Additionally, DonateLanka features a chat platform, enhancing communication and fostering a sense of community.`
      .split("\n\n")
      .map((paragraph, index) => <p key={index}>{paragraph}</p>),
  },
  {
    id: 3,
    techStack: [html, css, php, bootstrap, js, mysql, xampp],
    category: "Web",
    categoryLink: "fab fa-chrome",
    tag: "Project",
    tagLink: "fab fa-chrome",
    image: GymSite,
    title: "Platinum Fitness - GymSite (Website)",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://github.com/gitgunawardhana/gym-website",
    text: `Platinum Fitness is a web based platform designed to manage gym related activities. 

    This project was developed using HTML, PHP, JavaScript, CSS, Bootstrap, and MySQL as part of an individual project.`
      .split("\n\n")
      .map((paragraph, index) => <p key={index}>{paragraph}</p>),
  },
  {
    id: 4,
    techStack: [react, tailwind, nodejs, expressjs, mongodb, openAI],
    category: "Web",
    categoryLink: "fab fa-chrome",
    tag: "Project",
    tagLink: "fab fa-chrome",
    image: DalleClone,
    title: "DalleClone (Website)",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://github.com/gitgunawardhana/dalle-clone",
    text: `I've created DalleClone, a website that uses DALL-E AI to generate imaginative images and foster a community, leveraging React, Tailwind, MongoDB, NodeJS, Express, and the OpenAI API.`
      .split("\n\n")
      .map((paragraph, index) => <p key={index}>{paragraph}</p>),
  },
  {
    id: 5,
    techStack: [scenebuilder, hibernate, mysql, workbench, oop, java, github],
    category: "Desktop",
    categoryLink: "fas fa-desktop",
    tag: "Project",
    tagLink: "fas fa-desktop",
    image: MedicalCenter,
    title: "Patient Management System for a Medical Center (Desktop)",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://github.com/gitgunawardhana/MedicalCenter",
    text: `Designing and implementing a desktop application for a selected medical center to improve the quality and productivity of healthcare services. 

    The project aims to address the current manual processes involved in patient registration, queue management, prescription dispensing, and report generation. By leveraging technology, the goal is to enhance the overall patient experience and provide efficient and reliable healthcare services.`
      .split("\n\n")
      .map((paragraph, index) => <p key={index}>{paragraph}</p>),
  },
  {
    id: 6,
    techStack: [androidstudio, firebase, java],
    category: "Mobile",
    categoryLink: "fas fa-mobile",
    tag: "Project",
    tagLink: "fas fa-mobile",
    image: NoteApp,
    title: "NoteApp (Mobile App)",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://github.com/gitgunawardhana/noteapp-with-firebase-android-studio",
    text: `I've developed NoteApp, a mobile app for simple note-taking with user login, using Android Studio and Firebase.`
      .split("\n\n")
      .map((paragraph, index) => <p key={index}>{paragraph}</p>),
  },
  {
    id: 7,
    techStack: [androidstudio, java],
    category: "Mobile",
    categoryLink: "fas fa-mobile",
    tag: "Project",
    tagLink: "fas fa-mobile",
    image: SimpleCalculator,
    title: "SimpleCalculator (Mobile App)",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://github.com/gitgunawardhana/simple-calculator-android-studio",
    text: `I've developed a simple calculator mobile app using Android Studio. 

    #MobileAppDevelopment #AndroidStudio`
      .split("\n\n")
      .map((paragraph, index) => <p key={index}>{paragraph}</p>),
  },
  {
    id: 8,
    techStack: [electron, react, ts, tailwind, sqlite, github],
    category: "Desktop",
    categoryLink: "fas fa-desktop",
    tag: "Project",
    tagLink: "fas fa-desktop",
    image: JewelleryPOS,
    title: "Jewellery Management System for a jewellery store (Desktop)",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://github.com/Waverista/Nithyakala_Jewellery_Management_System",
    text: `Excited to unveil our collaborative endeavor – a revolutionary Jewelry Shop Management System meticulously crafted to elevate operational efficiency for store owners. Our comprehensive solution seamlessly handles inventory management, workshop integration, order billing, and sales reporting. 

Key Features:

- Inventory Management: Seamlessly add, update, and remove items, categories, and subcategories, providing a centralized hub for all product details.

- Workshop Integration: Effortlessly track workshop details, ensuring transparency and efficient collaboration with artisans and craftsmen.

- Order Billing: Generate, save, and print detailed order bills encompassing customer information, item descriptions, pricing, and advance payment records.

- Sales Reporting: Access insightful selling reports based on specified date ranges, empowering informed business decisions.

Tailored to meet the unique demands of the jewelry industry, this project integrates cutting-edge technologies, utilizing ElectronJS for cross-platform compatibility, React and TypeScript for a robust frontend, and Tailwind CSS for an intuitive design. The system's data integrity is upheld by SQLite. This group effort reflects our commitment to delivering high-quality solutions that redefine the landscape of jewelry store management.`
      .split("\n\n")
      .map((paragraph, index) => <p key={index}>{paragraph}</p>),
  },
  {
    id: 9,
    techStack: [
      react,
      js,
      ts,
      nodejs,
      expressjs,
      mongodb,
      html,
      tailwind,
      github,
    ],
    category: "Web",
    categoryLink: "fab fa-chrome",
    tag: "Project",
    tagLink: "fab fa-chrome",
    image: GrandCafe,
    title: "Jewellery Management System for a jewellery store (Desktop)",
    icon1: "fas fa-file-image",
    icon2: "fas fa-code-branch",
    link: "https://github.com/gitgunawardhana/grand-cafe",
    text: `The Grand Cafe Web Development Project is dedicated to enhancing the dining experience through a seamless online platform. Our website features an intuitive, mobile-optimized interface that facilitates online booking, order management, and a personalized meal ordering system.

At the core of the project is the goal of streamlining operations and elevating customer satisfaction. Speaking of standout features, the first one is our customized meal ordering system, empowering customers to create dishes aligned with their preferences. The online booking system, which simplifies table reservations with real-time availability updates, is another noteworthy feature. The site's modern, user-friendly design is optimized for mobile devices. Additionally, the Recipe Generation functionality allows users to input preferred ingredients for custom recipes, promoting kitchen creativity, reducing food waste, and enhancing the overall dining experience.

User Levels/User Roles:

- Guest User: Can browse the menu, access restaurant information, and enjoy public content. Cash on delivery option is available.

- Registered User: Enjoys all guest capabilities, with added features such as account management, preferences, online orders, table reservations, and feedback.

- Restaurant Admin: Manages the menu, bookings, orders, promotions, and customer feedback. Generates reports and analytics.

YouTube Link: https://www.youtube.com/watch?v=GmQNJkIz5DQ`
      .split("\n\n")
      .map((paragraph, index) => <p key={index}>{paragraph}</p>),
  },
];

export default ProjectData;
